import React, { Component } from "react";
import Select from 'react-select';
import { DateRangePicker, CustomProvider } from 'rsuite';
import { DatePicker } from 'rsuite';
import enUS from 'rsuite/locales/en_US';
import { callBackendAPI, handleFormValidation, handleFormInputs, generateSource, reFormatErrors } from './../../helpers/common';
import { STATUS_SUCCESS, DATE_RANGE_PICKER_FORMAT, SMS_LIMIT, SMS_TEMPLATE_DROPDOWN, SMS_SCHEDULE_DROPDOWN, SEND_LATER, SEND_NOW } from './../../config/global_constants';
import { translate } from './../../helpers/intl_helpers';

import sendIcon from './../../assets/images/send-sms-icon.svg';
import sendLaterIcon from './../../assets/images/send-sms-later.svg';

const locale = {
	...enUS,
	DateTimeFormats: {
		...enUS.DateTimeFormats,
		weekStart: 0 // Sunday
	}
};

export default class SendSms extends Component {
	constructor(props) {
		super(props)
		const weeks = this.generateWeeks();

		const defaultTemplate = SMS_TEMPLATE_DROPDOWN.find(
			item => item.value === 'schedule_notification'
		);

		const defaultScheduleType = SMS_SCHEDULE_DROPDOWN.find(
			item => item.value === SEND_NOW
		);

		this.state = {
			weeks,
			errors: {},
			fields: {
				schedule_type: defaultScheduleType,
				template_id: defaultTemplate,
				message: {
					value: ""
				}
			},
			submitted: false,
			bulkErrors: null,
			activeTab: 0,
			modalType: this.props.modalType,
			empList: [],
			weekEmpList: [],
			selectedTemplate: defaultTemplate
		};

		this.closeModal = this.closeModal.bind(this);
		this.handleFormInputs = this.handleFormInputs.bind(this);
		// this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.loadOptions = this.loadOptions.bind(this);
	}

	componentDidMount() {
		this.setCurrentWeek();
		this.getEmpList();
		this.getWeekEmpList();

		this.getSMSTemplates();
		// this.handleChangeTemplate(this.state.selectedTemplate);

		window.document.body.classList.add("modal-open");
		window.document.body.classList.add("overflow-hidden");
	}

	generateWeeks = () => {
		const today = new Date();
		const dayOfWeek = today.getDay();
		// Find the most recent Monday (or today if Monday)
		const daysToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
		const currentMonday = new Date(today);
		currentMonday.setDate(today.getDate() + daysToMonday);
		currentMonday.setHours(0, 0, 0, 0);

		return Array.from({ length: 6 }, (_, i) => {
			const from = new Date(currentMonday);
			from.setDate(currentMonday.getDate() + i * 7);
			const to = new Date(from);
			to.setDate(from.getDate() + 6);

			const label = i === 0 ? 'This Week' : i === 1 ? 'Next Week' : `Week ${i + 1}`;

			const fromMonth = from.toLocaleString('en-US', { month: 'short' });
			const toMonth = to.toLocaleString('en-US', { month: 'short' });
			const tabLabel = fromMonth === toMonth
				? `${fromMonth} ${from.getDate()}-${to.getDate()}`
				: `${fromMonth} ${from.getDate()} - ${toMonth} ${to.getDate()}`;

			return { label, from, to, tabLabel };
		});
	};

	setCurrentWeek = () => {
		const { weeks } = this.state;
		const today = new Date();
		const idx = weeks.findIndex(w => today >= w.from && today <= w.to);
		this.setState({ activeTab: idx >= 0 ? idx : 0 });
	};

	getEmpList = () => {
		this.source = generateSource();
		window.showLoader();
		const { weeks, activeTab, fields } = this.state;
		const isCustom = activeTab === 'custom';
		const customRange = fields.custom_date_range;
		const startDate = isCustom ? (customRange?.[0] || '') : (weeks[activeTab] || weeks[0])?.from || '';
		const endDate = isCustom ? (customRange?.[1] || '') : (weeks[activeTab] || weeks[0])?.to || '';
		callBackendAPI([{ model: 'calendar', method: 'employeeList', onCallSchedule: true, start_date: startDate, end_date: endDate, is_project_manager: true, complete_list: true }], this.source).then(response => {
			window.hideLoader();
			if (response.success && response.data[0].status === STATUS_SUCCESS && response.data[0].result) {
				this.setState({ isLoading: false, empList: response.data[0].result || [] });
			}
		}).catch(err => console.log(err));
	}

	getWeekEmpList = () => {
		this.source = generateSource();
		const { weeks, activeTab, fields } = this.state;

		const isCustom = activeTab === 'custom';
		const customRange = fields.custom_date_range;

		const startDate = isCustom ? (customRange?.[0] || '') : (weeks[activeTab] || weeks[0])?.from || '';

		const endDate = isCustom ? (customRange?.[1] || '') : (weeks[activeTab] || weeks[0])?.to || '';

		callBackendAPI([{ model: 'on_call', method: 'list', compose_sms: true, start_date: startDate, end_date: endDate }], this.source).then(response => {

			if (response.success && response.data[0].status === STATUS_SUCCESS) {
				// THIS IS ALREADY REACT-SELECT FORMAT
				let weekEmpList = response.data[0].skills || [];

				this.setState((prevState) => ({
					isLoading: false,
					weekEmpList,
					fields: {
						...prevState.fields,
						employee_ids: weekEmpList
					}
				}));
			}
		}).catch(err => console.log(err));
	}

	getSMSTemplates = () => {

		const { weeks, activeTab, fields, selectedTemplate } = this.state;

		const isCustom = activeTab === 'custom';
		const customRange = fields.custom_date_range;

		const startDate = isCustom
			? (customRange?.[0] || '')
			: (weeks[activeTab] || weeks[0])?.from || '';

		const endDate = isCustom
			? (customRange?.[1] || '')
			: (weeks[activeTab] || weeks[0])?.to || '';

		callBackendAPI([{
			model: 'on_call',
			method: 'sms-templates',
			template_id: selectedTemplate?.value || '',
			start_date: startDate,
			end_date: endDate
		}], this.source).then(response => {

			if (
				response.success &&
				response.data[0].status === STATUS_SUCCESS
			) {

				this.setState((prevState) => ({
					fields: {
						...prevState.fields,
						message: {
							value: (response.data[0]?.result?.message || "")
								.replace(/(<br\s*\/?>\s*)+/gi, '\n')
								.replace(/&nbsp;/gi, ' ')
								.trim()
						}
					}
				}));
			}

		}).catch(err => console.log(err));
	}

	/**
	* For load employee options
	*
	* @param inputValue		as 	search term
	* @param loadedOptions	as 	old options array
	* @param page			as 	page count
	*
	* @return json
	*/
	async loadOptions(inputValue, loadedOptions, { page }) {
		try {
			/** Generate source for cancel token */
			this.source = generateSource();

			const { weeks, activeTab, fields } = this.state;
			const isCustom = activeTab === 'custom';
			const customRange = fields.custom_date_range;
			const startDate = isCustom ? (customRange?.[0] || '') : (weeks[activeTab] || weeks[0])?.from || '';
			const endDate = isCustom ? (customRange?.[1] || '') : (weeks[activeTab] || weeks[0])?.to || '';

			let response = await callBackendAPI([{ model: 'on_call', method: 'list', compose_sms: true, emp_name: inputValue ? inputValue : '', start_date: startDate, end_date: endDate }], this.source);

			let resData = response && response.data && response.data[0] ? response.data[0] : {};
			let result = resData.skills ? resData.skills : [];

			return {
				options: result,
				hasMore: false,
				additional: { page: page + 1 },
			}

		} catch (error) {
			console.error('Error loading options:', error);
			return {
				options: [],
				hasMore: false,
				additional: { page: page },
			};
		}
	}

	/**
	* For manage form submit event
	*
	* @param e 	as 	current form object
	*
	* @return null
	*/
	handleFormSubmit(e) {
		e.preventDefault();

		const { template_id, employee_ids, message, schedule_type, schedule_date } = this.state.fields;
		const { weeks, activeTab, fields } = this.state;
		const isCustom = activeTab === 'custom';
		const customRange = fields.custom_date_range;

		let empArr = [];
		if (employee_ids && employee_ids.length) empArr = employee_ids.map(element => element.value);
		this.setState({
			submitted: true,
			fields: {
				...this.state.fields,
				...{
					employees: { value: empArr.length ? empArr : null }
				}
			}
		}, () => {

			let startDate = isCustom
				? (customRange?.[0] || new Date())
				: ((weeks[activeTab] || weeks[0])?.from || new Date());
			let endDate = isCustom
				? (customRange?.[1] || new Date())
				: ((weeks[activeTab] || weeks[0])?.to || new Date());

			/** Api Requested Data **/
			let params = [{
				model: 'on_call',
				method: 'send-sms',
				emp_id: this.state.emp_id ? this.state.emp_id : "",
				start_date: startDate,
				end_date: endDate,
				employee_ids: empArr,
				template_id: template_id?.value || "",
				message: message?.value || "",
				schedule_type: schedule_type?.value || "",
				schedule_date: schedule_date?.value || "",
			}];

			/** Validation Rules **/
			let validations = {
				employees: { label: translate('on_call.employee'), "rules": ["select"] },
				template_id: { label: translate('on_call.template'), "rules": ["select"] },
				schedule_type: { label: translate('on_call.schedule_type'), "rules": ["select"] },
				message: { label: translate('on_call.message'), "rules": ["required"] },
			}
			if (schedule_type?.value === SEND_LATER) {
				validations = {
					...validations,
					schedule_date: {
						label: translate('on_call.schedule_date'), rules: ["required"]
					}
				};
			}

			/** Handle validation and api response **/
			handleFormValidation(validations, this.state.fields, params, true, true, true).then(async (response) => {
				if (!response.success) return this.setState({ errors: response.errors, submitted: false });

				if (response.success && response.data.status === STATUS_SUCCESS) {
					/** Hide loader */
					this.closeModal();
					this.props.getOnCallList();

				} else if (response.data.message) {
					this.setState({ errors: reFormatErrors(response.data.message), submitted: false });
				}

			}).catch(err => console.log(err));
		});
	}

	/**
	* For hide model
	*
	* @return null
	*/
	closeModal() {
		window.document.body.classList.remove("modal-open");
		window.document.body.classList.remove("overflow-hidden");

		this.props.handelSendSms(false);
	}// end closeModal()

	/** Manage input change event */
	handleChange = (fieldName) => (fieldVal) => {
		this.setState((prevState) => {
			const newFields = { ...prevState.fields, [fieldName]: fieldVal };
			return { fields: newFields };
		});
	};

	/**
   * For update state fields values
   *
   * @param e  	as current field object
   * @param field  as current field name
   *
   * @return null
   */
	handleFormInputs(e, field) {
		let response = handleFormInputs(e, field, this.state.fields);
		this.setState({ response }, () => { });
	}// end handleFormInputs()

	handleMessageChange = (event) => {
		let value = event.target.value;

		// Optional: allow multiple SMS (160 * n)
		const maxLimit = SMS_LIMIT * 10; // allow up to 10 SMS (you can change)

		if (value.length > maxLimit) {
			value = value.slice(0, maxLimit);
		}

		this.setState((prevState) => ({
			fields: {
				...prevState.fields,
				message: { value }
			}
		}));
	};

	handleChangeTemplate = (selectedOption) => {

		const { weeks, activeTab, fields } = this.state;

		const isCustom = activeTab === 'custom';
		const customRange = fields.custom_date_range;

		const startDate = isCustom
			? customRange?.[0]
			: (weeks[activeTab] || weeks[0])?.from;

		const endDate = isCustom
			? customRange?.[1]
			: (weeks[activeTab] || weeks[0])?.to;

		const formatDate = (date) => {
			if (!date) return "";

			return date.toLocaleDateString('en-US', {
				month: 'long',
				day: 'numeric',
				year: 'numeric'
			});
		};

		// FRONTEND STATIC TEMPLATE
		if (selectedOption?.value === 'on_call_reminder') {

			let message = selectedOption?.message || "";

			message = message
				.replace(/\{\{start_date\}\}/g, formatDate(startDate))
				.replace(/\{\{end_date\}\}/g, formatDate(endDate));

			this.setState((prevState) => ({
				selectedTemplate: selectedOption,
				fields: {
					...prevState.fields,
					template_id: selectedOption,
					message: {
						value: message
					}
				}
			}));

			return;
		}

		// API TEMPLATE
		this.setState((prevState) => ({
			selectedTemplate: selectedOption,
			fields: {
				...prevState.fields,
				template_id: selectedOption
			}
		}), () => {
			this.getSMSTemplates();
		});
	};

	render() {
		const { weeks, activeTab, submitted, fields, empList } = this.state;

		const isCustom = activeTab === 'custom';
		const customRange = fields.custom_date_range;
		const weekData = isCustom
			? { from: customRange?.[0] || null, to: customRange?.[1] || null }
			: (weeks[activeTab] || weeks[0]);

		const formatBannerDate = (date) =>
			date ? date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : '—';

		const messageText = fields?.message?.value || "";
		const charCount = messageText.length;
		const smsCount = Math.ceil(charCount / SMS_LIMIT) || 1;
		const totalLimit = smsCount * SMS_LIMIT;
		const scheduleType = fields?.schedule_type?.value;

		return <>
			<div
				className="modal fade on-call-modal d-block show"
				id="send-smsModal"
				tabIndex={-1}
				aria-labelledby="add-employeeModalLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog modal-lg">
					<div className="modal-content">
						<div className="modal-header">
							<h2 className="modal-title fs-5" id="send-smsModalLabel">{translate("on_call.compose_sms")}</h2>
							<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => this.closeModal()}></button>
						</div>
						<form onSubmit={(event) => this.handleFormSubmit(event, 'SendSms')} noValidate>
							<div className="modal-body">
								<div className="sp-week-banner">
									<p className="sp-week-range mb-0"><strong className='me-1'>{translate("on_call.showing_on_call_for")}</strong> <span id="sp-week-label">{formatBannerDate(weekData?.from)} - {formatBannerDate(weekData?.to)}</span></p>
								</div>
								<div className="row filter-box top-0 mt-3">
									<div className="col-md-12">
										<div className="form-group">
											<label className="mb-1 form-label">{translate("on_call.date_filter")}</label>
											<div className="segmented-control">
												{weeks.map((week, i) => (
													<button
														key={i}
														type="button"
														className={`segment ${activeTab === i ? "active" : ""}`}
														onClick={() => {
															this.setState({
																activeTab: i,
																fields: {
																	...this.state.fields,
																	custom_date_range: null
																}
															}, () => {
																this.getWeekEmpList();
																this.getSMSTemplates();
															});
														}}
													>
														<span className="week-name">{week.label}</span>
														<span className="week-date">{week.tabLabel}</span>
													</button>
												))}
												<button
													type="button"
													className={`segment ${isCustom ? "active" : ""}`}
													onClick={() => {
														this.setState({
															activeTab: 'custom',
															fields: {
																...this.state.fields,
																employee_ids: null
															}
														});
													}}
												>
													{translate("on_call.custom")}
												</button>
											</div>
										</div>
									</div>

									{isCustom && (
										<div className="col-md-12">
											<div className="form-group">
												<label className="mb-1 form-label">{translate("on_call.custom_range")}</label>
												<CustomProvider locale={locale}>
													<DateRangePicker
														value={customRange || null}
														format={DATE_RANGE_PICKER_FORMAT}
														size="lg"
														className='form-control input-with-label date-range-picker-common'
														onChange={(val) => {
															this.setState({
																fields: {
																	...this.state.fields,
																	custom_date_range: val
																}
															}, () => {
																this.getWeekEmpList();
																this.getSMSTemplates();
															});
														}}
														placeholder={translate('reports.search_by_date')}
														cleanable={false}
														ranges={[]}
														editable={false}
													/>
												</CustomProvider>
											</div>
										</div>
									)}

									<div className="col-md-12">
										<div className="form-group multiselect-field">
											<label className="mb-1 form-label">{translate("on_call.to")} <span className='text-danger'>*</span></label>
											<Select
												className='custom-react-select '
												options={empList || []}
												value={fields.employee_ids ? fields.employee_ids : null}
												onChange={this.handleChange("employee_ids")}
												isClearable={true}
												placeholder={translate("on_call.select_employee")}
												isMulti
											/>
											<span className="error text-danger">{this.state.errors["employee_ids"]}</span>
											<span className="error text-danger">{this.state.errors["employees"]}</span>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group">
											<label className="mb-1 form-label">{translate("on_call.template")} <span className='text-danger'>*</span></label>
											<Select
												className='custom-react-select '
												options={SMS_TEMPLATE_DROPDOWN}
												value={this.state.selectedTemplate}
												onChange={(e) => this.handleChangeTemplate(e)}
												isClearable={true}
												placeholder={translate("on_call.select_a_template")}
											/>
											<span className="error text-danger">{this.state.errors["template_id"]}</span>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group">
											<label className="mb-1 form-label">{translate("on_call.schedule_type")} <span className='text-danger'>*</span></label>
											<Select
												className='custom-react-select '
												options={SMS_SCHEDULE_DROPDOWN}
												value={fields.schedule_type || null}
												onChange={this.handleChange("schedule_type")}
												isClearable={true}
												placeholder={translate("on_call.select_schedule_type")}
											/>
											<span className="error text-danger">{this.state.errors["schedule_type"]}</span>
										</div>
									</div>
									{scheduleType === SEND_LATER && (
										<div className="col-md-12">
											<div className="form-group">
												<label className="mb-1 form-label">
													{translate("on_call.schedule_date")} <span className='text-danger'>*</span>
												</label>

												<CustomProvider locale={locale}>
													<DatePicker
														className='form-control input-with-label date-range-picker-common'
														format="yyyy-MM-dd HH:mm"
														showMeridiem
														placeholder="Select date & time"
														style={{ width: "100%" }}
														placement="topStart"
														value={fields.schedule_date?.value || null}
														onChange={(val) => {
															this.setState({
																fields: {
																	...fields,
																	schedule_date: { value: val }
																}
															});
														}}
													/>
												</CustomProvider>
												<span className="error text-danger">{this.state.errors["schedule_date"]}</span>
											</div>
										</div>
									)}
									<div className="col-md-12">
										<div className="form-group">
											<label className="mb-1 form-label">{translate("on_call.message")} <span className='text-danger'>*</span></label>
											<textarea
												className="form-control"
												rows="8"
												name="message"
												id="message"
												value={messageText}
												placeholder={translate("on_call.message")}
												onChange={this.handleMessageChange}
											/>
											<div className="text-right message-length-info">
												{charCount} / {totalLimit} chars · {smsCount} SMS
											</div>
											<span className="error text-danger">{this.state.errors["message"]}</span>
										</div>
									</div>
								</div>
							</div>
							<div className="modal-footer">
								<button
									type={submitted ? "button" : "submit"}
									className="btn btn-fill"
								>
									{fields?.schedule_type?.value === SEND_NOW
										? translate('on_call.send_now')
										: translate('on_call.send_later')
									}
									<img className="ms-1" src={fields?.schedule_type?.value === SEND_NOW ? sendIcon : sendLaterIcon} alt="Submit" />

									{submitted && (
										<i className="spinner-border spinner-border-sm ms-3" />
									)}

								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div className="modal-backdrop fade show"></div>
		</>
	}
}
